import { ERequestStatus } from "generated/graphql";

export type RequestRejectionData = {
  reason: string;
  skipReason: boolean;
};

export const requestRejectionInitData: RequestRejectionData = {
  reason: null,
  skipReason: false,
};
export const requestsActions = (text: any) => {
  const actions = [
    {
      key: "edit",
      label: text.all.edit,
    },
    {
      key: "delete",
      label: text.all.delete,
    },
    {
      key: "accept",
      abilityFields: { status: [ERequestStatus.Requested] },
      label: "Accept",
    },
    {
      key: "decline",
      abilityFields: { status: [ERequestStatus.Requested] },
      label: "Decline",
    },
  ];
  return actions;
};
export const defaultRequestsActions = (text: any) => {
  const actions = [
    {
      key: "edit",
      label: text.all.edit,
    },
    {
      key: "delete",
      label: text.all.delete,
    },
  ];
  return actions;
};
